module.exports = __webpack_public_path__ + "static/media/csr_header_banner.1d8ba9bb.JPG";